// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-boxs[data-v-fcb32a2e] {\n  margin-left: 22px;\n  margin-bottom: -10px;\n}\n.title-tips[data-v-fcb32a2e] {\n  font-size: 12px;\n  color: #333;\n}\n.title-tips span[data-v-fcb32a2e] {\n  color: #999;\n}", ""]);
// Exports
module.exports = exports;
